var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import ReactSelect from 'react-select';
import Creatable from 'react-select/creatable';
import { AsyncSelect } from './AsyncSelect';
import { CreatableOption, BaseSelectComponents, Option, Control } from './BaseSelectComponents';
import { setInvariants, getValuesMappedToOptions, getSortedOptions, handleChange, handleCreateOption } from './lib';
import { OptimizedMenuList, optimizedFilter } from './OptimizedComponents';
export var Select = function (_a) {
    var id = _a.id, _b = _a.error, error = _b === void 0 ? '' : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, _d = _a.isInvalid, isInvalid = _d === void 0 ? false : _d, _e = _a.isTouched, isTouched = _e === void 0 ? false : _e, _f = _a.isOptimized, isOptimized = _f === void 0 ? false : _f, _g = _a.isSorted, isSorted = _g === void 0 ? false : _g, _h = _a.isFilteredByLabelOnly, isFilteredByLabelOnly = _h === void 0 ? false : _h, _j = _a.disabled, disabled = _j === void 0 ? false : _j, _k = _a.options, optionsFromProps = _k === void 0 ? [] : _k, labelKey = _a.labelKey, valueKey = _a.valueKey, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange, onBlur = _a.onBlur, handleSort = _a.handleSort, isMulti = _a.isMulti, isFormik = _a.isFormik, components = _a.components, isGrouped = _a.isGrouped, isCreatable = _a.isCreatable, isAsync = _a.isAsync, onCreateOption = _a.onCreateOption, otherProps = __rest(_a, ["id", "error", "isLoading", "isInvalid", "isTouched", "isOptimized", "isSorted", "isFilteredByLabelOnly", "disabled", "options", "labelKey", "valueKey", "value", "defaultValue", "onChange", "onBlur", "handleSort", "isMulti", "isFormik", "components", "isGrouped", "isCreatable", "isAsync", "onCreateOption"]);
    var currentValue = value || defaultValue;
    setInvariants(value, defaultValue, onChange, isMulti, currentValue);
    var sortedOptions = getSortedOptions(isSorted, isGrouped, labelKey, optionsFromProps, handleSort);
    var options = sortedOptions || optionsFromProps;
    var _l = getValuesMappedToOptions({
        options: options,
        value: value,
        defaultValue: defaultValue,
        valueKey: valueKey,
        isMulti: isMulti,
        isGrouped: isGrouped
    }), valueMappedToOption = _l.valueMappedToOption, defaultValueMappedToOption = _l.defaultValueMappedToOption;
    var enhancedHandleChange = function (value) {
        handleChange(value, onChange, valueKey, isMulti);
    };
    var enhancedHandleCreateOption = function (value) {
        handleCreateOption(value, isCreatable, onCreateOption, isMulti, valueMappedToOption, onChange, valueKey);
    };
    var remappedProps = {
        id: id,
        error: error,
        isLoading: isLoading,
        isInvalid: isInvalid,
        isTouched: isTouched,
        isDisabled: disabled,
        isMulti: isMulti,
        isGrouped: isGrouped,
        isFormik: isFormik,
        getOptionLabel: function (option) { return String(option[labelKey]); },
        getOptionValue: function (option) { return String(option[valueKey]); },
        options: options,
        value: valueMappedToOption,
        defaultValue: defaultValueMappedToOption,
        onBlur: onBlur,
        onChange: enhancedHandleChange,
        closeMenuOnSelect: !isMulti,
        blurInputOnSelect: !isMulti,
        'aria-labelledby': id ? id + "-label" : undefined
    };
    var commonProps = __assign(__assign(__assign({}, otherProps), remappedProps), { components: __assign(__assign({}, BaseSelectComponents), components) });
    if (isAsync) {
        return (React.createElement(AsyncSelect, __assign({}, commonProps, { 
            // we dont use the `value` or `defaultValue` from commonProps as it is calculated above
            // and the async needs the value not calculated
            value: value, defaultValue: defaultValue, valueKey: valueKey, isCreatable: isCreatable, isSorted: isSorted, labelKey: labelKey, handleSort: handleSort, onCreateOption: enhancedHandleCreateOption })));
    }
    if (isCreatable) {
        return (React.createElement(Creatable, __assign({}, commonProps, { onCreateOption: enhancedHandleCreateOption })));
    }
    var filterByLabel = function (option, inputValue) {
        var labelKey = option.label.toLowerCase();
        var val = inputValue.toLowerCase();
        return labelKey.includes(val);
    };
    var filterOption = isOptimized
        ? optimizedFilter
        : isFilteredByLabelOnly
            ? filterByLabel
            : undefined;
    return (React.createElement(ReactSelect, __assign({ filterOption: filterOption }, otherProps, remappedProps, { components: __assign(__assign({}, commonProps.components), (isOptimized ? { MenuList: OptimizedMenuList } : {})) })));
};
Select.Option = Option;
Select.Control = Control;
Select.CreatableOption = CreatableOption;
//# sourceMappingURL=Select.js.map